module.exports = __webpack_public_path__ + "media/components/assets/img/icons/contact-6e463485fabdefe72c03f5d833d15fab.svg";